let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k5dDK")).then(() => parcelRequire('iGIQS'));